var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-form',{attrs:{"action-type":"edit","list-value-data":_vm.listValueData,"submit-button-disabled":_vm.submitButtonDisabled,"loading":_vm.loading,"input-type":_vm.inputType},on:{"save":_vm.editValue,"updateListItems":_vm.updateListItems}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91aafede","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SystemManagement/SystemSettings/ListsSettings/UpdateList.vue
// module id = null
// module chunks = 